export default "__VITE_ASSET__VbAPI0LE__"